let siteAreas = [
  { name: `Homepage`, path: `/`, exactMatch: true },
  { name: `Product`, path: `/products/`, exactMatch: false },
  { name: `Cart`, path: `/cart`, exactMatch: true },
  {
    name: `Shop All`,
    path: `/collections/hero-teddy-bears`,
    exactMatch: true,
  },
  { name: `Collections`, path: `/collections/`, exactMatch: false },
];

let siteArea = siteAreas.find((area) => {
  if (area.exactMatch) {
    return location.pathname == area.path;
  } else {
    return location.pathname.includes(area.path);
  }
});

function trackEventsBySiteArea() {
  let links = [...document.querySelectorAll(`a`)];
  links.forEach((link) =>
    link.addEventListener(`click`, () => {
      gtag(`event`, `${siteArea} - Click`);
    })
  );
}

setTimeout(function () {
  if (!localStorage.getItem(`Logged Landing Page`)) {
    logLandingPage();
  }

  // Other Events
  logSiteArea(siteArea);
}, 1000);

function logLandingPage() {
  // Ensure gtag exists
  if (typeof window.gtag == "undefined") {
    setTimeout(logLandingPage, 100);
    return false;
  }

  gtag(`event`, `Landing Page`, { page: location.pathname });
  gtag(`event`, `Landing Page - ${location.pathname}`, {
    page: location.pathname,
  });
  localStorage.setItem(`Logged Landing Page`, true);
}

function logSiteArea(siteArea) {
  // Ensure gtag exists
  if (typeof window.gtag == "undefined") {
    setTimeout(logSiteArea, 100);
    return false;
  }

  let eventName = `Viewed ${siteArea.name}`;
  console.warn(eventName);

  let eventHasBeenSentBefore = checkForExistingEvent(eventName);

  if (siteArea && !eventHasBeenSentBefore) {
    gtag("event", eventName, {
      page: location.href,
      pageNumber: history.length,
    });
    logEvent(eventName);
  }
}

// Supporting Functions

function landingPageLogged() {
  return;
}

function checkForExistingEvent(eventName) {
  return localStorage.getItem(eventName);
}

function logEvent(eventName) {
  return localStorage.setItem(eventName, true);
}
